import React, { FC } from 'react';
import { ResultsProps } from '../types';

export const ResultsNone: FC<ResultsProps> = ({ id }) => {
  const testId = `${id}ResultsNone`;

  return (
    <div className="resultsNone" data-testid={testId} data-cy={testId}>
      <div className="labelResultsNone">No matching records</div>
    </div>
  );
};
